import { defaultPageInfo } from '@/common/constants/ConstCode';
import { isEmpty } from '@/common/utils/Util';

export default {
  setList: (state, list = []) => {
    state.list = list;
  },

  appendList: (state, list = []) => {
    state.list = [...state.list, ...list];
  },

  updatePage: state => {
    state.pagingCondition.page = state.pagingCondition.page + 1;
  },

  setNextId: (state, nextId = null) => {
    state.nextId = nextId;
  },

  setDetail: (state, detail = null) => {
    state.detail = detail;
  },

  initList: state => {
    state.list = [];
    state.nextId = null;
    state.pageInfo = { ...defaultPageInfo };
    state.pagingCondition.page = 1;
  }
};
